import { MutationTree } from 'vuex'

import { Booking, BookingsState, Mutations } from './types'

const mutations: MutationTree<BookingsState> = {
  [Mutations.SET_UPCOMING_BOOKINGS](state, bookings: Booking[]) {
    state.upcomingBookings = bookings
  },

  [Mutations.SET_PAST_BOOKINGS](state, bookings: Booking[]) {
    state.pastBookings = bookings
  },

  [Mutations.SET_NO_UPCOMING_BOOKINGS](state, noUpcomingBookings: boolean) {
    state.noUpcomingBookings = noUpcomingBookings
  },

  [Mutations.SET_NO_PAST_BOOKINGS](state, noPastBookings: boolean) {
    state.noPastBookings = noPastBookings
  },
}

export default mutations
